/*
 * Self-contained header navigation behaviour.
 * global.js / details-disclosure.js / component-menu-drawer.css are absent in
 * this theme, so the native <details>/<summary> elements have no JS. This adds:
 *  - mobile drawer: injected close button, body scroll-lock, close on link /
 *    overlay / Escape
 *  - desktop dropdowns: one-open-at-a-time + close on outside-click / Escape
 * No dependencies. Safe to run on every page.
 */
(function () {
  var container = document.querySelector('.menu-drawer-container');

  function setLock() {
    document.documentElement.classList.toggle('nav-drawer-open', !!(container && container.open));
  }

  if (container) {
    var drawer = container.querySelector('.menu-drawer');

    // Inject a visible close (X) button inside the drawer panel
    if (drawer && !drawer.querySelector('.js-drawer-close')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'js-drawer-close';
      btn.setAttribute('aria-label', 'Close menu');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function () { container.open = false; setLock(); });
      drawer.insertBefore(btn, drawer.firstChild);
    }

    container.addEventListener('toggle', setLock);

    // Close the drawer when a real link inside it is tapped (submenu toggles are
    // <summary>, not <a>, so they still expand normally)
    container.querySelectorAll('.menu-drawer a').forEach(function (a) {
      a.addEventListener('click', function () { container.open = false; setLock(); });
    });

    // Close when tapping the dim overlay (outside the drawer panel, not the summary)
    container.addEventListener('click', function (e) {
      if (container.open && !e.target.closest('.menu-drawer') && !e.target.closest('summary')) {
        container.open = false;
        setLock();
      }
    });
  }

  // Desktop dropdowns — open on hover (bykilian style), close on leave
  var navDetails = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu details'));
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

  navDetails.forEach(function (d) {
    var summary = d.querySelector('summary');
    var closeTimer;

    d.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      navDetails.forEach(function (o) { if (o !== d) o.open = false; });
      d.open = true;
    });
    d.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      closeTimer = setTimeout(function () { d.open = false; }, 150);
    });

    if (summary) {
      summary.addEventListener('click', function (e) {
        if (isDesktop()) {
          // hover controls the panel; don't let the click toggle it shut
          e.preventDefault();
        } else {
          setTimeout(function () {
            navDetails.forEach(function (o) { if (o !== d) o.open = false; });
          }, 0);
        }
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header__inline-menu')) {
      navDetails.forEach(function (d) { d.open = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      navDetails.forEach(function (d) { d.open = false; });
      if (container) { container.open = false; setLock(); }
    }
  });
})();
